import { MetacomState } from "@core/models/metacom.interface";
import { Action, createFeature, createReducer, on } from "@ngrx/store";
import { metacomActions } from "./actions";
import { metacomCreateRehydrateReducer } from "@shared/utils/state_rehydration.util";
import { MetacomDataDTO } from "@core/models/dto.models";

// Initial state setup
export const initialMetacomState: MetacomState = {
  isLoading: false,
  connected: false,
  momentCreated: false,
  data: {} as MetacomDataDTO, // Empty object for the data part
};

// Use the custom rehydration reducer
const metacomFeature = createFeature({
  name: "metacom",
  reducer: metacomCreateRehydrateReducer<MetacomState, Action>(
    "MetacomState", // Key for local storage
    createReducer(
      initialMetacomState,
      // Action handlers
      on(metacomActions.setMetacomDetails, (state) => ({
        ...state,
        isLoading: true,
        connected: false,
        momentCreated: false,
      })),
      on(metacomActions.setMetacomDetailsSuccess, (state, event) => ({
        ...state,
        isLoading: false,
        data: event.metacomDetails!, // Set data from action payload
      })),
      on(metacomActions.setMetacomDetailsFailed, () => ({
        ...initialMetacomState, // Reset state on failure
      })),
      on(metacomActions.requestMetacomConnection, (state) => ({
        ...state,
        isLoading: true,
        connected: false,
        momentCreated: false,
      })),
      on(metacomActions.requestMetacomConnectionSuccess, (state) => ({
        ...state,
        connected: true,
      })),
      on(metacomActions.requestMetacomConnectionFailed, (state) => ({
        ...state,
        isLoading: false,
      })),
      on(metacomActions.requestMetacomMoment, (state) => ({
        ...state,
      })),
      on(metacomActions.requestMetacomMomentSuccess, (state) => ({
        ...state,
        isLoading: false,
        momentCreated: true,
      })),
      on(metacomActions.requestMetacomMomentFailed, (state) => ({
        ...state,
        isLoading: false,
      })),
      on(metacomActions.resetMetacomStatuses, (state) => ({
        ...state,
        isLoading: false,
        connected: false,
        momentCreated: false,
      }))
    ),
    initialMetacomState // This is the initial state to be used if no rehydrated state exists
  ),
});

// Export the reducer
export const { name: metacomFeatureKey, reducer: metacomReducer } =
  metacomFeature;
